import React from 'react';
import { useIntl } from 'react-intl';
import { localeIds } from 'locals';
import PullToRefreshFunc from 'pulltorefreshjs';

export const SetPullToRefresh: React.FC = ({ children }) => {
  const intl = useIntl();

  const pullToRefreshMsg = intl.formatMessage({
    id: localeIds.pullToRefresh.pullToRefresh,
  });
  const releaseToRefreshMsg = intl.formatMessage({
    id: localeIds.pullToRefresh.releaseToRefresh,
  });
  const refreshingMsg = intl.formatMessage({
    id: localeIds.pullToRefresh.refreshing,
  });

  React.useEffect(() => {
    PullToRefreshFunc.init({
      mainElement: '#root',
      onRefresh() {
        window.location.reload();
      },
      instructionsPullToRefresh: pullToRefreshMsg,
      instructionsReleaseToRefresh: releaseToRefreshMsg,
      instructionsRefreshing: refreshingMsg,
    });
    return () => {
      PullToRefreshFunc.destroyAll();
    };
  }, [pullToRefreshMsg, releaseToRefreshMsg, refreshingMsg]);

  return <>{children}</>;
};
